import type { FC } from 'react';
import { PARTIAL_CHECK } from './sendRuleOutcomes';

interface SendPartialCheckProps {
  className?: string;
}

/**
 * Badge marking a rule, or a finding from one, whose check covers only part of the rule, so a pass
 * it gives never reads as the rule holding. Drawn on a span, like the source badge, because it sits
 * inside buttons and running text.
 */
const SendPartialCheck: FC<SendPartialCheckProps> = ({ className = '' }) => (
  <span
    className={`f6 lh-title dib br2 ba pa2 near-black b--light-yellow bg-light-yellow ${className}`}
    data-test-element="partial-check"
  >
    {PARTIAL_CHECK}
  </span>
);

export default SendPartialCheck;
